module.exports = __webpack_public_path__ + "static/feature-news1-92807d265d6132bccd80ee5a7d37f22e.png";